var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuotes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7529_12216)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.97875 21.6225C4.69125 20.255 4 18.7212 4 16.235C4 11.86 7.07125 7.93875 11.5375 6L12.6538 7.7225C8.485 9.9775 7.67 12.9037 7.345 14.7487C8.01625 14.4012 8.895 14.28 9.75625 14.36C12.0113 14.5687 13.7888 16.42 13.7888 18.7213C13.7888 19.8816 13.3278 20.9944 12.5073 21.8148C11.6869 22.6353 10.5741 23.0963 9.41375 23.0963C8.77206 23.0907 8.13789 22.9576 7.54816 22.7045C6.95843 22.4515 6.42494 22.0837 5.97875 21.6225ZM18.4788 21.6225C17.1912 20.255 16.5 18.7212 16.5 16.235C16.5 11.86 19.5713 7.93875 24.0375 6L25.1538 7.7225C20.985 9.9775 20.17 12.9037 19.845 14.7487C20.5162 14.4012 21.395 14.28 22.2562 14.36C24.5112 14.5687 26.2887 16.42 26.2887 18.7213C26.2887 19.8816 25.8278 20.9944 25.0073 21.8148C24.1869 22.6353 23.0741 23.0963 21.9137 23.0963C21.2721 23.0907 20.6379 22.9576 20.0482 22.7045C19.4584 22.4515 18.9249 22.0837 18.4788 21.6225Z",
    fill: "#1A1A1A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7529_12216"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuotes);
export default __webpack_public_path__ + "static/media/quotes.8522571d97153d2c226a1dce2e7fb0e1.svg";
export { ForwardRef as ReactComponent };